import { Components } from "@thisgorilla/primate-ds";
import { useEffect, useRef, useState } from "react";
import { useTheme } from "styled-components";
import { PostsProps } from "../../../redux/slices/posts/Posts";
import { FlexRowCenter } from "../Styles";
import AuthorInfoCardProps from "./AuthorInfoCard";
import { AvatarGroupContainer, Container, Wrapper } from "./style";

const AuthorInfoCard = ({
  mode,
  authorData,
  backgroundColor,
}: AuthorInfoCardProps.Props) => {
  const [width, setWidth] = useState(0);
  const { typography, Color } = useTheme();
  const childRef = useRef<HTMLDivElement>(null);
  const parentRef = useRef<HTMLDivElement>(null);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [selectedAvatar, setSelectedAvatar] = useState(1);
  const isSingleAuthor = authorData.length === 1;
  const selectedAuthor: PostsProps.Collaborator = isSingleAuthor
    ? authorData[0]
    : authorData[selectedAvatar - 1];
  const color =
    mode === "ColourAdapt" ? "#F3F5F6" : Color.text["text-primary"].value;

  useEffect(() => {
    if (parentRef.current && childRef.current) {
      const width = isCollapsed
        ? parentRef.current.clientWidth + 24
        : parentRef.current.clientWidth + childRef.current.clientWidth + 28;
      setWidth(width);
    }
  }, [isCollapsed, selectedAvatar, isSingleAuthor, authorData]);

  return (
    <Container
      $width={width}
      $gapInPx={isCollapsed ? 12 : 4}
      $backgroundColor={backgroundColor ?? ""}
      $isSingleAuthor={isSingleAuthor}
    >
      {isSingleAuthor && (
        <Components.Avatar
          size="Medium-48"
          src={selectedAuthor.profile_picture}
          type="Circle"
        />
      )}
      <Wrapper ref={childRef} $isSingleAuthor={isSingleAuthor}>
        <Components.Text
          style={{ tokenStyle: typography.Body.M }}
          text={selectedAuthor.name}
          color={color}
          fontWeight="font-weight-bold"
          renderInSingleLine={!isSingleAuthor}
        />
        <Components.Text
          style={{ tokenStyle: typography.Body.S }}
          text={selectedAuthor.name}
          color={color}
          renderInSingleLine={!isSingleAuthor}
        />
      </Wrapper>
      {!isSingleAuthor && (
        <FlexRowCenter ref={parentRef}>
          <AvatarGroupContainer
            $selectedAvatar={selectedAvatar}
            $isCollapsed={isCollapsed}
          >
            <Components.AvatarGroup
              size="Medium-48"
              srcCountToBeRendered={authorData.length}
              src={authorData.map((author) => author.profile_picture)}
              onAvatarClick={(avatarIndex) => {
                setSelectedAvatar(avatarIndex);
              }}
            />
          </AvatarGroupContainer>

          <div>
            <Components.IconButton
              disabled={false}
              iconType={isCollapsed ? "ChevronLeft" : "ChevronRight"}
              kind="Secondary"
              IconButtonColor={color}
              size="Medium"
              onClick={() => {
                setIsCollapsed(!isCollapsed);
              }}
            />
          </div>
        </FlexRowCenter>
      )}
    </Container>
  );
};

export default AuthorInfoCard;
